import { useState } from 'react'
import { IoChevronUp, IoChevronDown } from 'react-icons/io5'
import { FaCheck } from 'react-icons/fa'

import {
  Container,
  InfoContainer,
  HorizontalLine,
  Row,
  Column,
  Title,
  Label,
  InfoText,
  MoneyText,
  DetailsToggle,
  IconBox
} from './styles'

export default function Plan ({
  selected,
  data: plan,
  discount,
  enableToggle = false,
  style ={},
  onClick: handleClick = () => null
}) {
  const [showDetails, setShowDetails] = useState (true)

  const toggleDetails = () => setShowDetails (!showDetails)

  return (
    <Container selected={selected} onClick={handleClick} style={style}>
      <Title>{plan.name}</Title>
      <Column>
        <Row style={{justifyContent: 'space-between'}}>
          <InfoText>
            <MoneyText value={plan.price}/>
            {` / mês`}
          </InfoText>
          <InfoText style={{marginBottom: -2}}>
            (Recorrente)
          </InfoText>
        </Row>
        <HorizontalLine/>
        {discount && (
          <Column style={{padding: 0}}>
            <InfoText>
              Sua empresa paga:&ensp;
              <MoneyText value={discount} style={{fontSize: 14}}/>
            </InfoText>
            <InfoText>
              Seus colaboradores pagam:&ensp;
              <MoneyText value={plan.price - discount} style={{fontSize: 14}}/>
            </InfoText>
          </Column>
        )}
      </Column>
      {enableToggle && (
        <DetailsToggle onClick={toggleDetails}>
          {showDetails ? (
            <IoChevronUp size={24} color='#272727'/>
          ) : (
            <IoChevronDown size={24} color='#272727'/>
          )}
        </DetailsToggle>
      )}
      {showDetails && (
        <InfoContainer>
          {plan.description.split ('-').map ((item, index) => (
            <Row key={index}>
              {index > 0 && (
                <IconBox>
                  <FaCheck color='#FFC100' size={14}/>
                </IconBox>
              )}
              <Label>{item}</Label>
            </Row>
          ))}
        </InfoContainer>
      )}
    </Container>
  )
}
